module.exports = __webpack_public_path__ + "static/media/Contact.d33b4ed3.jpg";